import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import DropdownAction from 'components/Dropdown/DropdownAction';
import Icon from 'components/Icon';
import TooltipWrapper from 'components/Tooltip';
import {setUrl} from 'utils/request';
import {Document} from '../../services';
import PayDropdownOption from './PayDropdownOption';

interface ClientInboxDropdownProps {
    disabled: boolean;
    document: Document;
    portalMid: string;
}

const ClientInboxDropdown: FC<ClientInboxDropdownProps> = ({
    disabled = false,
    document,
    portalMid,
}) => {
    const {t} = useTranslation('Portal');

    if (document.isInaccessible) {
        return (
            <TooltipWrapper message={t('inbox.inaccessible')}>
                <Button
                    className="text-xs flex gap-1.5 select-none items-center whitespace-nowrap"
                    data-disabled={disabled}
                    disabled={true}
                    kind="secondary"
                    size="xs"
                >
                    {t('inbox.action')}
                    <Icon
                        className="flex-none"
                        icon="small_arrow_down"
                        size="base"
                    />
                </Button>
            </TooltipWrapper>
        );
    }

    return (
        <DropdownAction
            classNameAction="w-fit"
            kind="secondary"
            label={t('inbox.action')}
            size="xs"
        >
            <DropdownAction.Button
                onClick={() => {
                    const newWindow: Window | null = window.open(
                        `/portal/${portalMid}/client-inbox/file-download/${document.mid}/`,
                    );

                    if (newWindow) {
                        newWindow.opener = null;
                    }
                }}
            >
                {t('inbox.download')}
            </DropdownAction.Button>
            <PayDropdownOption
                moneyRequest={document.moneyRequest}
                onClick={() =>
                    setUrl(
                        `/portal/${portalMid}/client-inbox/${document.mid}/?history`,
                    )
                }
            />
            <DropdownAction.Button
                onClick={() =>
                    setUrl(
                        `/portal/${portalMid}/client-inbox/${document.mid}/?history`,
                    )
                }
            >
                {t('inbox.preview')}
            </DropdownAction.Button>
        </DropdownAction>
    );
};

export default ClientInboxDropdown;
